import Scramble from 'react-scramble'
import { Link } from 'react-router-dom'
import VisibilitySensor from 'react-visibility-sensor'
import { motion } from 'framer-motion'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

import metamarko from '../assets/team/metamarko.png'
import metatrippy from '../assets/team/metatrippy.png'
import metakat from '../assets/team/metakat.png'
import metazuzu from '../assets/team/metazuzu.png'
import metajb from '../assets/team/metajb.png'
import metarick from '../assets/team/metarick.jpeg'
import metamike from '../assets/team/metamike.png'
import andy from '../assets/team/andy.png'
import ant from '../assets/team/ant.png'
import jetmade from '../assets/team/jetmade.png'
import metajaytee from '../assets/team/metajaytee.png'

const people = [
	{
		name: 'MetaMarko',
		imageUrl: metamarko,
		bio: "MetaMarko is one of the visionaries behind MetaTravelers and has been working in immersive art and live entertainment for the past decade. As an experience creator, he has designed lighting shows for NBA, MLB, and NFL halftime shows, along with music festivals including Lollapalooza, Bonnaroo, Ultra Music Festival, and EDC. Over that time he did lighting design with musical artists such as Tiesto and Avicii, and most recently created the laser show design for Childish Gambino’s “This is America Tour''. In 2020 he teamed up with Trippyogi to create Next Dimension Studios and explore immersive art installations that bridge physical and digital experiences in the Metaverse. This fascination with NFT's and the future of open worlds sparked the creation of a collection to empower a community of creators and collectors while pushing the limits of next-gen avatars and XR technology.",
		twitter: 'https://twitter.com/marko_louis',
		opensea: 'https://opensea.io/Meta-Marko'
	},
	{
		name: 'MetaTrippy | trippyogi',
		imageUrl: metatrippy,
		bio: 'Trippyogi is a digital dream builder creating new worlds through art and technology. Whether it be through architecting spaces in the metaverse, cross-reality experiences, or moving meditations, every creation comes from a place of peace and love.',
		twitter: 'https://twitter.com/trippyogi',
		instagram: 'https://instagram.com/trippyogi',
		opensea: 'https://opensea.io/trippyogi'
	},
	{
		name: 'MetaKat',
		imageUrl: metakat,
		bio: 'MetaKat has almost a decade of experience working for a real estate marketing and sales brokerage. She has worked with some of the top builders in North America, helping them succeed in their development ventures. MetaKat has been a part of the Next Dimension Studios team since its creation! This emerging new world has engulfed my life in an exciting new way, and I can’t wait for the adventures to come. When I’m not working on the world of MetaTravelers, you can find me outside soaking up the sun and hiking with my dog! MetaKat focuses on social media marketing and team building for MetaTravelers, and is super amped to be building the future with such a highly motivated and innovative community!',
		twitter: 'https://twitter.com/ChattyKathy8989'
	},
	{
		name: 'MetaZuzu',
		imageUrl: metazuzu,
		bio: "Zuzu (aka princexzuzu - she/they) is a scrum master by day, project manager/coordinator/concept artist by night. What drives Zuzu the most in expanding the MetaTravelers universe is the vision of traversing the infinite metaverse worlds from the perspective of the Nibiru and other forthcoming guilds themselves! She recently started collecting NFT's with digital real estate in SuperWorld, and plans to install AR artworks in the physical world to spread messages of love and share really, really weird art.",
		instagram: 'https://instagram.com/princexzuzu',
		twitter: 'https://twitter.com/princexzuzu'
	},
	{
		name: 'MetaJB',
		imageUrl: metajb,
		bio: 'Joydeep is a self taught 3d artist extensively experienced in character art. From scribbling lead to molding digital clay, he does it all to make the characters come to life. Being relatively new in the nft space, he is excited to finally be able to pursue his new passion - creating a universe inside the metaverse!',
		instagram: 'https://instagram.com/art.joy.life',
		artstation: 'https://artstation.com/joydeepbairagi'
	},
	{
		name: 'MetaRick',
		imageUrl: metarick,
		bio: 'Rick is a lifelong artist, starting with doodles of Ninja Turtles as a child to co-founding a design firm, working as a professional graphic designer and illustrator. A newcomer to the NFT community, Rick is thrilled at the opportunity to learn more while connecting with like-minded art lovers. When not working you can catch Rick drinking coffee, listening to 90s hip-hop, and (still) drawing Ninja Turtles.',
		instagram: 'https://instagram.com/RickDrawsThings',
		twitter: 'https://twitter.com/RickDrawsThings',
		opensea: 'https://opensea.io/RickDrawsThings'
	},
	{
		name: 'MetaMike',
		imageUrl: metamike,
		bio: 'Mike is a developer with strong experience in planning and building early-stage startups. He is skilled in all aspects of developing software, from UI design to creating APIs to cloud architecture. His hobbies include spending all day refreshing OpenSea to view floor prices and accidentally selling NFTs before price pumps.',
		twitter: 'https://twitter.com/0xMeowdy',
		opensea: 'https://opensea.io/meowdy'
	},
	{
		name: 'JetMade',
		imageUrl: jetmade,
		bio: 'JetMade is an Island kid born and bred in the city of LA. He has over 8 years of experience in the film/entertainment industry. Currently, JetMade is the head of film at Kaskade music and owner of JetMade Film Co. He is a lover of all things tech/sci-fi and plants. JetMade’s dream is to one day move his family to a farm on the beach in the Philippines.',
		instagram: 'https://instagram.com/jetmade_',
		website: 'https://jetmade.co'
	},
	{
		name: 'Andy',
		imageUrl: andy,
		bio: "Andy has worked for over thirty years as a writer and artist creating characters and story worlds across many platforms: comics, books, video games, TV and film. He is best known for his work writing Marvel's Guardians of the Galaxy comic series, the source material for the smash hit movies. Recently, Andy spent eight years as the Executive Creative Director for Magic Leap helping to define the company's creative ethos and spearheading partnerships with some of the world’s leading creative practitioners from The Royal Shakespeare Company and Imaginarium Studios to Sigur Ros and Weta Workshop. In 2020 Andy teamed up with Ant to form Ideas&Inks a studio that helps companies develop their storyworlds using the tools and language of comics. MetaTravelers as a great opportunity to explore new forms of storytelling alongside a great team and an awesome community.",
		twitter: 'https://twitter.com/AndyLanning',
		website: 'https://ideasandinks.com'
	},
	{
		name: 'Ant',
		imageUrl: ant,
		bio: "Ant has enjoyed a long career as storyteller, artist, creative director, and a head of studios in the UK and US. He spent many years working on who's who of characters and IP for Marvel, DC, and multiple other comic-book publishers. Much of this work remains in print today and has featured in exhibitions of comic book art. He was the founder of a celebrated content creation house serving entertainment, advertising and licensing clients, working with them to develop their IP, turning ideas into commercially viable products. Ant also developed his own creative IP which he licenses internationally. As Head of Studio at Magic Leap, Ant was responsible for the 1st party content strategy and led a world class creative team who brought to life award winning content, helping to define a new entertainment medium in mixed reality. Having worked together since the beginning of their careers, Ant and Andy decided to set up Ideas&Inks to change the world one story at a time. MetaTravelers is a fantastic opportunity to be part of something truly groundbreaking.",
		instagram: 'https://instagram.com/taoastudio',
		website: 'https://ideasandinks.com'
	},
	{
		name: 'MetaJayTee',
		imageUrl: metajaytee,
		bio: 'MetaJayTee is a senior executive marketer with over 15+ years experience working with some of the largest brands in North America. He’s a digital first marketer with expertise in business strategy, building new ventures and launching brands in the market.  A regular conference speaker and association member, he has worked for multiple global companies. Fun fact - MetaJayTee was already working with AR marketing campaigns over 10 years ago!'
	}
]

export default function Team() {
	return (
		<div id='team'>
			<div className='relative px-4 py-32 mx-auto md:py-52 lg:py-72 max-w-7xl sm:px-6 lg:px-8'>
				<div className='pb-24 text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl orbitron'>
					<VisibilitySensor>
						{({ isVisible }) => (
							<Scramble
								autoStart={isVisible}
								text='Team'
								steps={[
									{
										roll: 10,
										action: '+',
										type: 'all'
									},
									{
										action: '-',
										type: 'forward'
									}
								]}
							/>
						)}
					</VisibilitySensor>
				</div>
				<div className='flex justify-center'>
					<div>
						<ul className='space-y-12 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 lg:gap-y-12 lg:space-y-0'>
							{people.map(person => (
								<li key={person.name}>
									<div className='space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8'>
										<div>
											<div className='flex justify-center'>
												<div>
													<LazyLoadImage
														className='object-cover w-40 h-40'
														src={person.imageUrl}
														effect='blur'
														alt={person.name}
													/>
												</div>
											</div>

											<div className='flex justify-center my-4 space'>
												{person.twitter ? (
													<a
														className='mr-3'
														href={person.twitter}
														target='_blank'
														rel='noreferrer'
													>
														<i className='text-gray-300 hover:text-white fab fa-twitter fa-lg'></i>
													</a>
												) : (
													<></>
												)}
												{person.instagram ? (
													<a
														className='mr-3'
														href={person.instagram}
														target='_blank'
														rel='noreferrer'
													>
														<i className='text-gray-300 hover:text-white fab fa-instagram fa-lg'></i>
													</a>
												) : (
													<></>
												)}

												{person.website ? (
													<a
														className='mr-3'
														href={person.website}
														target='_blank'
														rel='noreferrer'
													>
														<i className='text-gray-300 hover:text-white fas fa-globe fa-lg'></i>
													</a>
												) : (
													<></>
												)}

												{person.artstation ? (
													<a
														className='mr-3'
														href={person.artstation}
														target='_blank'
														rel='noreferrer'
													>
														<i className='text-gray-300 hover:text-white fab fa-artstation fa-lg'></i>
													</a>
												) : (
													<></>
												)}

												{person.opensea ? (
													<a
														href={person.opensea}
														target='_blank'
														rel='noreferrer'
													>
														<svg
															className='mt-0.5 text-gray-300  hover:fill-current hover:text-white'
															width='20'
															height='20'
															viewBox='0 0 90 90'
															fill='none'
															xmlns='http://www.w3.org/2000/svg'
														>
															<path
																d='M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z'
																fill='currentColor'
															/>
														</svg>
													</a>
												) : (
													<></>
												)}
											</div>
										</div>
										<div className='sm:col-span-2'>
											<div className='space-y-4'>
												<div className='space-y-1 text-xl font-medium leading-6 text-white orbitron-no-glow'>
													<h3>{person.name}</h3>
												</div>
												<div className='text-base'>
													<p className='text-gray-400'>
														{person.bio}
													</p>
												</div>
											</div>
										</div>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
				<div id='join-the-team'></div>
				<div className='mt-52'>
					<div className='flex justify-center'>
						<div className='mb-6 text-4xl font-bold text-white orbitron-no-glow'>
							We're Hiring!
						</div>
					</div>
					<div className='flex justify-center'>
						<Link to='/join-the-team'>
							<motion.button
								className='px-4 py-3 cta-button orbitron-no-glow'
								whileHover={{ boxShadow: '0 0 8px #fff' }}
							>
								Join The Team
							</motion.button>
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}
